import { createContext } from 'react';

export const P2PContext = createContext({});
